import { combineReducers } from 'redux';
import * as actionTypes from '../action-mgr/actionTypes';

const selectedStationName = (state = "", action) => {
    switch (action.type) {
      case actionTypes.SET_SELECTED_STATION_NAMES:
        return action.stationName;
      default:
        return state;
    }
}

const currentDownloadReportStation = (state = "", action) => {
  switch (action.type) {
    case actionTypes.CURRENT_DOWNLOAD_REPORT_STATION:
      return action.stationName;
    default:
      return state;
  }
}

//new Date().getMonth() + 1
const selectedMonth = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_DOWNLOAD_REPORT_MONTH:
      return action.month;
    default:
      return state;
  }
}

//new Date().getFullYear()
const selectedYear = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_DOWNLOAD_REPORT_YEAR:
      return action.year;
    default:
      return state;
  }
}

const downloadReportCheckObject = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.CHECK_DOWNLOAD_REPORT_OBJECT:
      return {
        ...state,
        downloadReportStationYear: action.data ? action.data.year : undefined,
        downloadReportStationMonth: action.data ? action.data.month : undefined,
      };
    default:
      return state;
  }
};



const downloadReportListObject = (state = [], action) => {
  switch (action.type) {
    case actionTypes.LIST_DOWNLOAD_REPORT_OBJECT:
      return {
        ...state,
        downloadReportList: action.data, 
      };
    default:
      return state;
  }
};

export default combineReducers({
  selectedStationName,
  currentDownloadReportStation,
  selectedYear,
  selectedMonth,
  downloadReportCheckObject,
  downloadReportListObject
});

const getCurrentState = state => state.downloadRequests.downloadReport;
export const getSelectedStationName = state => getCurrentState(state).selectedStationName;
export const getCurrentDownloadReportStation = state => getCurrentState(state).currentDownloadReportStation;
export const getSelectedYear = state => getCurrentState(state).selectedYear;
export const getSelectedMonth = state => getCurrentState(state).selectedMonth;
export const getDownloadReportCheck = state => getCurrentState(state).downloadReportCheckObject;
export const listDownloadReportObject = state => getCurrentState(state).downloadReportListObject;


